export class LoadRuleTwoEntity{

    id:number;
    name:string;
    active:boolean;
    creationDate:string;
    ruleId:number;

    constructor (){}
}